import React, { useState, useEffect } from "react";
import {
    MDBTable,
    MDBTableHead,
    MDBTableBody
} from 'mdb-react-ui-kit';
import { Row, Col, Breadcrumb, Card, Form, Table } from 'react-bootstrap';
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { Link, useNavigate } from 'react-router-dom'; // Assuming React Router is used
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import config from '../config';
import { Sidebar } from 'primereact/sidebar';
import { toWords } from "number-to-words";
import moment from "moment";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import successVideo from '../assets/video/paperplane.mp4';
import { Dialog } from 'primereact/dialog';
import CustomConfirmPopup from "../components/CustomConfirmPopup";
import { ToWords } from "to-words";
import InvoiceSearchBar, { EMPTY_INVOICE_SEARCH, toInvoiceSearchParams } from "./InvoiceSearchBar";

const Recurring_Invoice = () => {
    const { accessToken } = useAuth();
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
    // State Variables for Search Filters
    const [templateName, setTemplateName] = useState('');
    const [financialYear, setFinancialYear] = useState('');
    const [searchFilters, setSearchFilters] = useState(EMPTY_INVOICE_SEARCH);
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [dateRange, setDateRange] = useState({ startDate: moment().startOf("month"), endDate: moment().endOf("month") });
    const [years, setYears] = useState([]); // State for storing financial years
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const currencySymbols = {
        INR: "₹ ",
        USD: "$ ",
        GBP: "£ ",
        EUR: "€ ",
        AED: "د.إ ",
        AUD: "A$ ",
        CAD: "C$ "
    };

    const getCurrencySymbol = (currencyCode) => {
        return currencySymbols[currencyCode] || currencyCode; // Default to currency code if not found
    };

    const handleDateRangeChange = (start, end) => {
        setDateRange({ startDate: moment(start), endDate: moment(end) });
    };


    /*------------to-words function --------------*/
    const currencyWordConfig = {
        INR: { name: "Rupee", plural: "Rupees", fraction: "Paisa", fractionPlural: "Paise" },
        USD: { name: "Dollar", plural: "Dollars", fraction: "Cent", fractionPlural: "Cents" },
        EUR: { name: "Euro", plural: "Euros", fraction: "Cent", fractionPlural: "Cents" },
        GBP: { name: "Pound", plural: "Pounds", fraction: "Pence", fractionPlural: "Pence" },
        AED: { name: "Dirham", plural: "Dirhams", fraction: "Fils", fractionPlural: "Fils" },
        AUD: { name: "Australian Dollar", plural: "Australian Dollars", fraction: "Cent", fractionPlural: "Cents" },
        CAD: { name: "Canadian Dollar", plural: "Canadian Dollars", fraction: "Cent", fractionPlural: "Cents" }
    };

    // ⭐ SAME FUNCTION USED IN BOTH PAGES
    const convertAmountToWordsView = (amount, currencyCode) => {
        const c = currencyWordConfig[currencyCode] ?? currencyWordConfig["INR"];

        // Use Indian format only for INR
        const locale = currencyCode === "INR" ? "en-IN" : "en-US";

        const toWords = new ToWords({
            localeCode: locale,
            converterOptions: {
                currency: true,
                ignoreDecimal: false,
                currencyOptions: {
                    name: c.name,
                    plural: c.plural,
                    symbol: currencySymbols[currencyCode],
                    fractionalUnit: {
                        name: c.fraction,
                        plural: c.fractionPlural,
                        symbol: ""
                    }
                }
            }
        });

        return toWords.convert(amount);
    };




    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/fetch-all-templates`, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });

                if (response.status === 200 && response.data.data.length > 0) {
                    setTemplates(response.data.data);
                } else {
                    setTemplates([]);
                }
            } catch (error) {
                console.error('Error fetching templates:', error);
            }
        };

        fetchTemplates();
    }, [accessToken]);

    const openDialog = (invoiceId) => {
        setSelectedInvoiceId(invoiceId);
        setShowDialog(true);
    };

    const handleTemplateChange = (event) => {
        const selectedId = event.target.value; // Get selected template_id
        const selected = templates.find((template) => template.template_id.toString() === selectedId);
        setSelectedTemplate(selected || null);
    };


    const handleSave = async () => {
        if (!selectedTemplate || !selectedInvoiceId) return;
        setShowDialog(false);
        await duplicateInvoice(selectedInvoiceId, selectedTemplate);
    };


    const fetchFinancialYears = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes//unique-financial-years`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
            setYears(response.data.financial_years); // Update state with fetched years
        } catch (error) {
            console.error("Error fetching financial years:", error);
        }
    };
    useEffect(() => {
        fetchFinancialYears();
    }, [accessToken]); // Run once on mount



    // Fetch Invoices Function
    const fetchInvoices = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/fetch-recurring-invoices`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: {
                    template_name: templateName,
                    financial_year: financialYear,
                    ...toInvoiceSearchParams(searchFilters),
                    startDate: dateRange.startDate.format("YYYY-MM-DD"),
                    endDate: dateRange.endDate.format("YYYY-MM-DD"),
                }
            });
            setInvoices(response.data.data || []);
        } catch (error) {
            console.error("Error fetching invoices:", error);
        }
        setLoading(false);
    };

    // Fetch data when component mounts or filters change
    useEffect(() => {
        fetchInvoices();
    }, [accessToken, templateName, financialYear, dateRange, searchFilters]);



    const deleteInvoice = async (invoiceId) => {
        setLoading(true); // Show loader

        try {
            const response = await axios.delete(
                `${config.apiBASEURL}/InvoiceRoutes/delete-invoice/${invoiceId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                setLoading(false); // Stop loading
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 5 seconds
                    fetchInvoices(); // Refresh invoice list after deletion
                }, 5000);
            }
        } catch (error) {
            console.error("Error deleting invoice:", error);
        } finally {
            setLoading(false); // Hide loader
        }
    };

    const duplicateInvoice = async (invoiceId, template) => {
        setLoading(true); // Show loader

        try {
            const response = await axios.post( // Changed to POST since duplication is not usually a DELETE operation
                `${config.apiBASEURL}/InvoiceRoutes/duplicate/${invoiceId}`,
                {
                    template_id: template.template_id,
                    template_name: template.template_name,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                setLoading(false); // Stop loading
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 5 seconds
                    fetchInvoices(); // Refresh invoice list after duplication
                }, 5000);
            }
        } catch (error) {
            console.error("Error duplicating invoice:", error);
        } finally {
            setLoading(false); // Hide loader
        }
    };



    const SendInvoice = async (invoiceId) => {
        setLoading(true); // Show loader

        try {
            const response = await axios.post( // Changed to POST since duplication is not usually a DELETE operation
                `${config.apiBASEURL}/InvoiceRoutes/send-invoice`,
                { invoice_id: invoiceId },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.status === 200) {
                setLoading(false); // Stop loading
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 5 seconds
                    fetchInvoices(); // Refresh invoice list after duplication
                }, 5000);
            }
        } catch (error) {
            console.error("Error duplicating invoice:", error);
        } finally {
            setLoading(false); // Hide loader
        }
    };



    return (
        <>
            <InvoiceSearchBar onChange={setSearchFilters}>
                    <div>
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-search" />
                            <InputText
                                value={templateName}
                                onChange={(e) => setTemplateName(e.target.value)}
                                placeholder=" Template Name"
                                className='border-0 border-bottom ps-5 respWidth'
                                style={{ width: '180px' }}
                            />
                        </IconField>
                    </div>
                    <div>
                        <Form.Select
                            value={financialYear}
                            onChange={(e) => setFinancialYear(e.target.value)}
                            className="border-0 border-bottom respWidth"
                            style={{ width: "180px" }}
                        >
                            <option value="">Select Year</option>
                            {years.map((year, index) => (
                                <option key={index} value={year}>{year}</option>
                            ))}
                        </Form.Select>
                    </div>
                    <div>
                        <DateRangePicker
                            initialSettings={{
                                startDate: dateRange.startDate,
                                endDate: dateRange.endDate,
                                locale: { format: "DD/MM/YYYY" },
                                ranges: {
                                    Today: [moment(), moment()],
                                    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                                    "Last Month": [
                                        moment().subtract(1, "month").startOf("month"),
                                        moment().subtract(1, "month").endOf("month"),
                                    ],
                                },
                            }}
                            onCallback={(start, end) => handleDateRangeChange(start, end)}
                        >
                            <input
                                type="text"
                                className="form-control mx-lg-2 mx-0 respWidth "
                                style={{ width: "200px" }}
                                placeholder="Select Date Range"
                            />
                        </DateRangePicker>

                    </div>
            </InvoiceSearchBar>
            <div className="resp_report">
                <MDBTable responsive hover className='Departtable'>
                    <MDBTableHead className="sticky-top" style={{ backgroundColor: '#e1ebff' }}>
                        <tr>
                            <th scope='col'>Invoice Id</th>
                            <th scope='col'>Client</th>
                            <th scope='col'>DESC</th>
                            <th scope='col'>Currency</th>
                            <th scope='col'> Date</th>
                            <th scope='col'>Amount</th>
                            <th scope='col'>Action</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                        {loading ? (
                            <tr>
                                <td colSpan="9" className="text-center">Loading...</td>
                            </tr>
                        ) : invoices.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="text-center">No invoices found</td>
                            </tr>
                        ) : (
                            invoices.map((invoice) => (
                                <tr key={invoice.invoice_id}>
                                    <td>{invoice.template?.invoice_prefix}_/{invoice.financial_year}</td>
                                    <td>
                                        <Link to={`/Graphe/dashboard/view_client/${invoice.specificInvoices?.Client_id}`} >
                                            {invoice.specificInvoices?.bill_name}
                                        </Link>
                                        <span className="d-block">
                                            <Button
                                                className="p-button-sm p-0"
                                                icon="pi pi-phone"
                                                rounded
                                                text
                                                severity="success"
                                                tooltip={invoice.specificInvoices?.phone}
                                                tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            />
                                            <Button
                                                className="p-button-sm p-0"
                                                icon="pi pi-envelope"
                                                rounded
                                                text
                                                severity="primary"
                                                tooltip={invoice.specificInvoices?.email}
                                                tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            />
                                        </span>
                                    </td>
                                    <td>
                                        <p className="m-0"><small> </small> {invoice.template_name}</p>
                                        <p className="m-0"><small> </small> {invoice.remarks}</p>
                                    </td>
                                    <td>{invoice.currency}</td>

                                    <td>
                                        <p className="m-0"><small>Issue Date:  {new Date(invoice.issue_date).toLocaleDateString('en-GB')}</small> </p>
                                        <p className="m-0"><small className="text-danger">Due Date:    {new Date(invoice.due_date).toLocaleDateString('en-GB')}</small></p>
                                        <p className="m-0"><small className="text-info">Recurring Date: {new Date(invoice.recurring_date).toLocaleDateString('en-GB')}</small></p>
                                    </td>


                                    <td>
                                        <p className="m-0"><small>Cost: </small> <b>{invoice.sub_total}</b></p>
                                        {invoice.lut ? (
                                            <p className="m-0"><small>LUT ARN No: </small> <b>{invoice.Lut_Arn_No}</b></p>
                                        ) : (
                                            <>
                                                <p className="m-0"><small>Tax Type: </small> <b>{invoice.tax_type}</b></p>
                                                <p className="m-0"><small>Tax: </small> <b>{invoice.tax}</b></p>
                                            </>
                                        )}
                                        <p className="m-0"><small>Total: </small> <b>{invoice.total}</b></p>
                                    </td>

                                    <td>
                                        <Button
                                            icon="pi pi-eye"
                                            rounded
                                            text
                                            aria-label="Filter"
                                            severity="info"
                                            tooltip="View"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            onClick={() => {
                                                setSelectedInvoice(invoice); // Set the selected invoice
                                                setVisibleRight(true); // Show the sidebar/modal
                                            }}
                                        />
                                        <Button
                                            icon="pi pi-file-edit"
                                            rounded
                                            text
                                            aria-label="Filter"
                                            severity="help"
                                            tooltip="Edit"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                            onClick={() => navigate(`/Graphe/dashboard/edit_invoice/${invoice.invoice_id}`)}
                                        />
                                        {/* <CustomConfirmPopup
                                            message="Are you sure you want to Send this Invoice?"
                                            icon="pi pi-exclamation-triangle"
                                            defaultFocus="accept"
                                            acceptClassName="p-button-success"
                                            buttonLabel="Send"
                                            title="Send Invoice"
                                            buttonClass="p-button-success p-button-text"
                                            className="border-0 p-0"
                                            buttonIcon="pi pi-send"
                                            onConfirm={() => SendInvoice(invoice.invoice_id)}
                                            onReject={() => console.log('Send action canceled')}
                                        /> */}

                                        <Button

                                            icon="pi pi-clone"
                                            onClick={() => openDialog(invoice.invoice_id)}
                                            rounded
                                            text
                                            aria-label="Filter"
                                            severity="warning"
                                            tooltip="Duplicate Invoice"
                                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                                        />

                                        <CustomConfirmPopup
                                            message="Are you sure you want to delete this Invoice?"
                                            icon="pi pi-exclamation-triangle"
                                            defaultFocus="accept"
                                            acceptClassName="p-button-danger"
                                            buttonLabel="Delete"
                                            title="Delete Invoice"
                                            buttonClass="p-button-danger p-button-text"
                                            className="border-0 p-0"
                                            buttonIcon="pi pi-trash"
                                            onConfirm={() => deleteInvoice(invoice.invoice_id)}
                                            onReject={() => console.log('Delete action canceled')}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </MDBTableBody>

                </MDBTable>
            </div>


            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} className="resp_sidewidth" style={{ width: '50vw' }}>
                {selectedInvoice && (

                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '0', fontFamily: 'Roboto', background: '#fff' }}>
                        <thead>
                            <tr style={{ borderBottom: '1px solid #ddd' }}>
                                <td colspan="3" style={{ padding: '10px', Width: '300px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={selectedInvoice.logo_url || require("../assets/images/logo.png")} alt="Company Logo" style={{ height: '170px', width: '170px', objectFit: 'contain' }} />
                                        <div style={{ width: 'calc(100% - 120px)', marginLeft: '30px' }}>
                                            <h2 style={{ margin: '5px 0 0 0', fontSize: '20px', color: '#494949', textTransform: 'uppercase' }}>The Graphē</h2>
                                            <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: '400', color: '#858585' }}>A Design Studio</p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', lineHeight: '20px', color: '#494949', width: '200px' }}>{selectedInvoice.template?.company_address || "N/A"}</p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>GSTIN No. : <b>{selectedInvoice.template?.GSTIN}</b></p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>MSME No. : <b>{selectedInvoice.MSME_Number}</b> <small style={{ color: '#858585' }}>({selectedInvoice.MSME_Type})</small></p>
                                            {selectedInvoice.lut && (<p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>LUT No. : <b>{selectedInvoice.Lut_Arn_No}</b></p>)}
                                        </div>
                                    </div>
                                </td>
                                <td style={{ padding: "10px", textAlign: "right", verticalAlign: "top", width: "280px", paddingLeft: "65px" }} colspan="2" >
                                    <h3 style={{ margin: "5px 0 10px 0", fontSize: "26px", color: "#000" }}>{selectedInvoice.template_name}</h3>

                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" style={{ padding: "8px 0" }}></td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ padding: "10px 15px 10px 10px", verticalAlign: "top" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Bill To :</p>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.bill_name}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Poc : </span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.poc}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Email : </span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.email || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.phone || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>GSTIN :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.gstin || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.bill_address || "N/A"}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td colSpan="2" style={{ padding: "10px", verticalAlign: "top" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Ship To :</p>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.shipping_name}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.shipping_phone}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", lineHeight: "1.3", marginTop: "5px" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)", }}>
                                                {selectedInvoice.shipping_address}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td colSpan="1" style={{ padding: "10px", verticalAlign: "top", width: "200px" }}>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Invoice # :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {selectedInvoice.invoice_code}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Issue Date :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {new Date(selectedInvoice.issue_date).toLocaleDateString("en-GB")}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Due Date :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {new Date(selectedInvoice.due_date).toLocaleDateString("en-GB")}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5" style={{ padding: '10px 0' }}></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ backgroundColor: '#e7e7e7', textAlign: 'left' }}>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '230px' }}>Description</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>SAC/HSN</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Rate</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Qty</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '100px' }}>Sub Total</th>
                            </tr>
                            {selectedInvoice?.invoiceProducts?.map((product, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        <span style={{ display: 'block', marginBottom: '3px' }}>{index + 1}. {product.description}</span>
                                        {product.Remarks && (
                                            <small style={{ fontSize: '11px', lineHeight: '1.2' }} className="text-secondary d-block">
                                                <b>Remarks :</b> {product.Remarks}
                                            </small>
                                        )}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {product.hsn ? `HSN-${product.hsn}` : product.sac_code ? `SAC-${product.sac_code}` : '-'}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {getCurrencySymbol(selectedInvoice.currency)} {product.price}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>{product.quantity}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {getCurrencySymbol(selectedInvoice.currency)} {product.subtotal_price}
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <th colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Subtotal:</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.sub_total}</th>
                            </tr>
                            {selectedInvoice.tax_type === "Cgst+Sgst" && (
                                <>
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>CGST ({selectedInvoice.cgst}%):</td>
                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.cgst_value.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>SGST ({selectedInvoice.sgst}%):</td>
                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.sgst_value.toFixed(2)}</td>
                                    </tr>
                                </>
                            )}
                            {selectedInvoice.tax_type === "Igst" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>IGST ({selectedInvoice.igst}%):</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.igst_value.toFixed(2)}</td>
                                </tr>
                            )}
                            {selectedInvoice.tax_type === "GST" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>GST ({selectedInvoice.gst}%):</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.gst_value.toFixed(2)}</td>
                                </tr>
                            )}
                            {selectedInvoice.supplyAttractReverses === "Yes" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Supply Attract Reverse Charge :</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Yes</td>
                                </tr>
                            )}
                            <tr style={{ backgroundColor: '#e7e7e7' }}>
                                <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '18px' }}>Total:</td>
                                <td style={{ border: '1px solid #ddd', fontWeight: '600', padding: '6px 10px', fontSize: '18px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.total}</td>
                            </tr>
                            <tr>
                                {/* <td colSpan={5} style={{ padding: '10px 10px 10px 0' }}>
                                        <p style={{ margin: 0, fontSize: '13px' }}>
                                            Total amount (in words) : <span style={{ fontWeight: '500', paddingLeft: '5px' }}>{selectedInvoice.currency} {toWords(selectedInvoice.total).toUpperCase()} Only.</span>
                                        </p>
                                    </td> */}
                                <td colSpan={5} style={{ padding: '10px 10px 10px 0' }}>
                                    <p style={{ margin: 0, fontSize: '13px' }}>
                                        Total amount (in words) :
                                        <span style={{ fontWeight: '500', paddingLeft: '5px' }}>
                                            {selectedInvoice.currency} {convertAmountToWordsView(selectedInvoice.total, selectedInvoice.currency).toUpperCase()}.
                                        </span>
                                    </p>
                                </td>
                            </tr>
                            {selectedInvoice.remarks && (
                                <tr>
                                    <td colSpan={5} style={{ padding: '10px 10px 10px 0', verticalAlign: 'top' }}>
                                        <p style={{ margin: 0 }}>
                                            <span style={{ fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>Remarks :</span>
                                            <span style={{ fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>{selectedInvoice.remarks}</span>
                                        </p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="5" style={{ padding: "10px 0" }}></td>
                            </tr>
                            <tr>
                                <td colSpan="3" style={{ padding: "15px 10px", verticalAlign: "top", borderTop: "1px solid #ddd" }}>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ paddingRight: "10px", textAlign: "center" }}>
                                            <p style={{ margin: "0 0 6px 0", fontSize: "12px", fontWeight: 600 }}>Pay Using UPI :</p>
                                            <img
                                                src="https://ik.imagekit.io/blackboxv2/Graphe-logo/Graphe%CC%84%20QR%20Code.png?updatedAt=1743494152821"
                                                alt="UPI QR Code"
                                                style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                            />
                                            <small style={{ display: "block", fontSize: "12px", fontWeight: 400 }}>
                                                yashashwi.malani@okhdfcbank
                                            </small>
                                        </div>

                                        <div style={{ width: "calc(100% - 120px)", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                                            <p style={{ margin: "0 0 6px 0", fontSize: "13px", fontWeight: 600 }}>Bank Details :</p>
                                            <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                                <li style={{ display: "flex", marginBottom: "3px" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C Name :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)", lineHeight: 1.3 }}>
                                                        {selectedInvoice.template?.company_name || "N/A"}
                                                        <small style={{ margin: "2px 0 0px 0", fontSize: "11px", fontWeight: 400, color: "#858585", display: "block" }}>
                                                            Pay By CHEQUE/DD/RTGS/NEFT
                                                        </small>
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Bank :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.bank_name || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C NO :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.account_number || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>IFSC :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.ifsc_code || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Branch :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.bank_branch || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Swift Code :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.swift_code || "N/A"}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                                <td style={{ padding: "15px 10px", textAlign: "right", verticalAlign: "top", borderTop: "1px solid #ddd" }} colSpan="2">
                                    <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                                        <div>
                                            <small style={{ marginRight: "50px" }}>
                                                <img
                                                    src="https://ik.imagekit.io/blackboxv2/Graphe-logo/stamp.jpeg?updatedAt=1737015027907"
                                                    alt="Stamp"
                                                    style={{ width: "80px", height: "80px", objectFit: "contain" }}
                                                />
                                            </small>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <p style={{ display: "block", fontSize: "14px", margin: "0 0 18px 0", fontWeight: 500 }}>
                                                <small>For The Graphē</small>
                                            </p>
                                            <img src={selectedInvoice.signature_url} alt="Signature" style={{ width: "80px", height: "80px" }} />
                                            <p style={{ display: "block", fontSize: "14px", margin: "18px 0 0 0", fontWeight: 400 }}>
                                                <small>Authorised Signatory</small>
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ backgroundColor: "#f7f7f7" }}>
                                <td colSpan="5" style={{ padding: "10px 10px 0 10px", color: "#575757" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "13px", fontWeight: 600 }}>
                                        <span>Terms and Conditions : </span>
                                    </p>
                                    {[
                                        "Payment: Due within 7 days. Late payments attract interest as per the MSME Act, 2006.",
                                        "Interest on Late Payment: As per Section 16 of the MSME Act, 2006, delays beyond 45 days from the invoice date will attract interest at *24% P.A*",
                                        "Intellectual Property: Final designs are transferred upon full payment. Unpaid concepts remain the agency’s property.",
                                        "For 194(C),TDS under new Secion at 2% under Section 393(1)-Table Sl No.6(iii)D(a) : Code-1026.",
                                        "For 194(J),TDS under new Secion at 10% under Section 393(1)-Table Sl No.6(iii)D(b) : Code-1027.",
                                        "Taxes: GST applicable as per law. Any tax changes are the client’s responsibility.",
                                        "Payment: 50% advance before initiation of project and balance before final deliverables.",
                                        "Jurisdiction: Disputes fall under Kolkata, West Bengal, jurisdiction.",
                                        "A valid purchase order or work order is required for the commencement of the project."
                                    ].map((text, index) => (
                                        <p key={index} style={{ margin: "0 0 5px 0", fontSize: "12px", fontWeight: 400 }}>{index + 1}. {text}</p>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" style={{ backgroundColor: "#313030", padding: "10px 15px", textAlign: "center" }}>
                                    <small style={{ fontSize: "13px", fontWeight: 400, color: "#fff" }}>
                                        Call: {selectedInvoice.template?.contact_no || "N/A"} &nbsp;| &nbsp;
                                        Email: <a href={`mailto:${selectedInvoice.template?.email}`} style={{ color: "#fff" }}>{selectedInvoice.template?.email || "N/A"}</a>
                                    </small>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </Sidebar>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>

            {/* Template Selection Dialog */}
            <Dialog
                header="Select Template"
                visible={showDialog}
                style={{ width: "350px" }}
                onHide={() => setShowDialog(false)}
            >
                <Form.Group className="mb-3">
                    <Form.Select onChange={handleTemplateChange} value={selectedTemplate?.template_id || ""}>
                        <option disabled value="">Select Template</option>
                        {templates.length > 0 ? (
                            templates.map((template) => (
                                <option key={template.template_id} value={template.template_id}>
                                    {template.template_name} / {template.invoice_prefix} / {template.financial_year}
                                </option>
                            ))
                        ) : (
                            <option disabled>No Templates Available</option>
                        )}
                    </Form.Select>

                </Form.Group>

                {/* Action Buttons */}
                <div className="d-flex justify-content-end gap-2">
                    <Button label="Cancel" className="p-button-text" onClick={() => setShowDialog(false)} />
                    <Button
                        label="Select"
                        className="p-button-primary"
                        onClick={handleSave}
                        disabled={!selectedTemplate}
                    />
                </div>
            </Dialog>
        </>
    );
};
export default Recurring_Invoice
